import React from "react";
import "./style.less";
import { useSelector, useDispatch } from "react-redux";
import {
  addVisibleLayer,
  removeVisibleLayer
} from "../../../../redux/geofence/actions";

function LowerMenu() {
  const layers = useSelector(({ geofence }) => geofence.visibleLayers);
  const dispatch = useDispatch();

  return (
    <div className="LowerMenu-main">
      <ul>
        <li
          className={layers.indexOf("geofence") !== -1 ? `active` : ""}
          onClick={
            layers.indexOf("geofence") === -1
              ? () => dispatch(addVisibleLayer("geofence"))
              : () => dispatch(removeVisibleLayer("geofence"))
          }
        >
          Polygon Map
        </li>
        <li
          className={layers.indexOf("heatmap") !== -1 ? `active` : ""}
          onClick={
            layers.indexOf("heatmap") === -1
              ? () => dispatch(addVisibleLayer("heatmap"))
              : () => dispatch(removeVisibleLayer("heatmap"))
          }
        >
          Order Heatmap
        </li>

        {/* TODO: Improve orderpin rendering till then disabled.
          <li
          className={layers.indexOf("orderpins") !== -1 ? `active` : ""}
          onClick={
            layers.indexOf("orderpins") === -1
              ? () => dispatch(addVisibleLayer("orderpins"))
              : () => dispatch(removeVisibleLayer("orderpins"))
          }
        >
          Order Pins
        </li>*/}
      </ul>
    </div>
  );
}

LowerMenu.defaultProps = {};

LowerMenu.propTypes = {};

export default LowerMenu;
